module.exports = __webpack_public_path__ + "img/background-login.75e43581.png";